import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

const ZoomableImage =React.memo(({ src, alt }) => {
  const [open, setOpen] = useState(false);

  const handleImageClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <img
        src={src}
        className = "table-image"
        alt={alt}
        style={{ cursor: 'pointer' }}
        onClick={handleImageClick}
      />
      <Dialog open={open} onClose={handleClose} maxWidth="md">
        <DialogTitle>Zoomed Image</DialogTitle>
        <DialogContent>
          <img src={src.replace("http:","https:")} alt={alt} style={{ width: '100%' }} />
        </DialogContent>
      </Dialog>
    </>
  );
});

export default ZoomableImage;
